import React from 'react';
import { cn } from '@/lib/utils';
import { API_URL } from '../../apiBase';

/** URL affichable pour médias tutoriel (proxy Annuaire ou absolu). */
export function resolveHelpMediaUrl(url) {
  if (url == null) return null;
  const u = String(url).trim();
  if (!u) return null;
  if (u.startsWith('data:') || u.startsWith('http://') || u.startsWith('https://')) {
    return u;
  }
  if (u.startsWith('/api/')) {
    return `${API_URL}${u}`;
  }
  return u;
}

export function toYoutubeEmbed(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    if (u.hostname.includes('youtu.be')) {
      const id = u.pathname.replace('/', '').split('/')[0];
      return id ? `https://www.youtube.com/embed/${id}` : null;
    }
    if (u.hostname.includes('youtube.com')) {
      const v = u.searchParams.get('v');
      if (v) return `https://www.youtube.com/embed/${v}`;
      const m = u.pathname.match(/\/embed\/([^/]+)/);
      if (m) return `https://www.youtube.com/embed/${m[1]}`;
    }
  } catch {
    return null;
  }
  return null;
}

/** Index 0-based ; seules les valeurs entières ≥ 1 dans l’URL ; sinon étape 1. */
export function parseStepQueryParam(raw, numSteps) {
  const steps = Math.max(0, Number(numSteps) || 0);
  const n = parseInt(String(raw ?? '').trim(), 10);
  if (!Number.isFinite(n) || n < 1) return 0;
  const idx = n - 1;
  if (steps <= 0) return 0;
  return Math.min(idx, steps - 1);
}

/** Bulles / commentaires positionnés sur la capture (données Prysma). */
export function StepPositionedBubbles({ etape }) {
  if (!etape || typeof etape !== 'object') return null;
  const raw = etape.bulles ?? etape.overlays ?? etape.annotations;
  if (!Array.isArray(raw) || raw.length === 0) return null;
  return (
    <>
      {raw.map((b, i) => {
        if (!b || typeof b !== 'object') return null;
        const left = b.left_pct ?? b.left ?? b.x_pct ?? b.x;
        const top = b.top_pct ?? b.top ?? b.y_pct ?? b.y;
        if (left == null || top == null) return null;
        const w = b.width_pct ?? b.width;
        const h = b.height_pct ?? b.height;
        const msg = String(b.texte ?? b.text ?? b.content ?? '').trim();
        if (!msg) return null;
        const tone = String(b.style ?? b.type ?? 'info').toLowerCase();
        const borderClass =
          tone === 'warn' || tone === 'warning'
            ? 'border-amber-500'
            : tone === 'error' || tone === 'danger'
              ? 'border-red-500'
              : 'border-blue-500';
        return (
          <div
            key={i}
            className={cn(
              'absolute z-[1] max-w-[min(90%,18rem)] rounded-lg border-2 bg-slate-800 p-3 shadow-xl',
              borderClass,
            )}
            style={{
              left: `${Number(left)}%`,
              top: `${Number(top)}%`,
              transform: 'translate(-50%, -50%)',
              ...(w != null && w !== '' ? { width: `${Number(w)}%` } : {}),
              ...(h != null && h !== '' ? { height: `${Number(h)}%` } : {}),
            }}
          >
            <p className="text-sm font-medium text-slate-100">{msg}</p>
          </div>
        );
      })}
    </>
  );
}
